var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-container"},[_c('site-header',{attrs:{"statusAction":_vm.statusAction}}),_c('site-header-bottom'),_c('router-view',{on:{"status-action":_vm.onStatusAction}}),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }